import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { getBaseName } from '../common/Utils';
import MonthCombo from '../common/MonthCombo';
import YearCombo from '../common/YearCombo';
import EnforcementNewsTable from './EnforcementNewsTable';
import { Helmet } from 'react-helmet';
import { queryByTestId } from '@testing-library/react';
import { replacedoamin } from '../common/Utils';


class EnforcementNewsListPanel extends Component {
    constructor(props) {
        super(props);

        const { history } = this.props;
        
        if ( typeof(history.location.state) === 'undefined' ) {
            history.replace(history.location.path,{pageNo:0});
        }

        window.scrollTo(0, 0);
        
        this.state = {
            query: {
                lang: props.match.params.lang,
                category: props.category,
                year: "all",//new Date().getFullYear(),
                month: "all",
                ceTargetName: "",
                searchMode: "by-year",
                pageNo: history.location.state['pageNo'],
                pageSize: 20,
                isLoading: true,
                errors: null,
                items: null,
                total: -1
            }
        };
    }

    mergeQuery(updates) {
        let state = this.state;
        let mergedQuery = Object.assign({},state.query,updates);
        state.query = mergedQuery;
        return state;
    }

    async refreshTable() {
        const apiUrl = `${getBaseName()}/api/news/search`;
        const { query } = this.state;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(query)
        }


        let updates = {};
        try {            
            const response = await fetch(apiUrl,options);
            window.scrollTo(0, 0);
            if (response.status === 200) {
                const result = await response.json();

                //console.log(result);

                updates = {
                    items: result.items,
                    total: result.total,
                    errors: null                    
                };
            } else {

            }
        } catch (error) {
            //console.log(error);
            updates = {
                errors: error
            };
        } finally {
            updates['isLoading'] = false;
            const state = this.mergeQuery(updates);
            this.setState(state);
        }
    }

    componentDidMount() {

        setTimeout(() => {this.refreshTable();},1500)

        if (typeof window.writeMenu === "function") { 
            window.writeMenu();
        }

    }

    handleYearChange(e) {
        e.preventDefault();
        const updates = { year: e.target.value, pageNo: 0, isLoading: true };
        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }

    handleMonthChange(e) {
        e.preventDefault();
        const updates = { month: e.target.value, pageNo: 0, isLoading: true };
        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }

    handleCeTargetNameChange(e) {        
        const updates = { ceTargetName: e.target.value };
        const state = this.mergeQuery(updates);
        this.setState(state);
    }

    handleNameSearch(e,ceTargetName) {
        //console.log(e);
        if ( ceTargetName !== undefined && ceTargetName !== null) {
            const updates = { ceTargetName: ceTargetName, searchMode: "by-name", month: "all", year: "all", pageNo: 0, items: [], total: 0 };
            const state = this.mergeQuery(updates);
            this.setState(state);
        } else {
            const updates = { month: "all", year: "all", pageNo: 0, items: [], total: 0 };
            const state = this.mergeQuery(updates);
            this.setState(state);
        }
        this.refreshTable();
    }

    handleSwitchMode(e) {
        e.preventDefault();
        if ( "by-year" === this.state.query.searchMode ) {
            const updates = { searchMode: "by-name", ceTargetName: "", month: "all", year: "all", pageNo: 0, items: [], total: 0 };
            const state = this.mergeQuery(updates);
            this.setState(state);
        } else {
            const updates = { searchMode: "by-year", ceTargetName: "", month: "all", year: "all", pageNo: 0, items: [], total: 0 };
            const state = this.mergeQuery(updates);
            this.setState(state);
            this.refreshTable();
        }
    }

    handlePageChange(data) {
        const updates = { pageNo: data.selected, isLoading: true };

        const { history } = this.props;
        history.replace(history.location.path,{pageNo:data.selected});
        
        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }
    
    render() {
        const { t } = this.props;
        const { query } = this.state;
        const REACT_APP_APPS_DOMAIN = `${process.env['REACT_APP_APPS_DOMAIN']}`;
        const gaScript = `
            var _gaq = _gaq || []; 
            _gaq.push(['_setAccount', '${process.env['REACT_APP_GA_ID']}']); 
            _gaq.push(['_setDomainName', '${REACT_APP_APPS_DOMAIN}']); 
            _gaq.push(['_trackPageview']); 
            
            (function () { 
            var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true; 
            ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js'; 
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s); 
            })();
        `;

        const ga4ScriptId = `${process.env['REACT_APP_GA4_ID']}`;

        const ga4Script = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
        
            gtag('config', '${process.env['REACT_APP_GA4_ID']}');      
        `;

        let category = this.props.category;
        category = (category === undefined)?"all":category;

        let searchSection;
        if ( "by-name" === query.searchMode ) {
            searchSection = (
                <div className="search-section enforcement-news">
                    <input type="text" name="search-content" 
                        value={query.ceTargetName}
                        onChange={this.handleCeTargetNameChange.bind(this)}></input>
                    <input type="button" 
                        className="btn btn-primary"
                        value={t("enforcement.button.search")}
                        onClick={this.handleNameSearch.bind(this)}></input>
                    <input type="button" 
                        className="btn btn-primary"
                        value={t("enforcement.button.viewByYear")}
                        onClick={this.handleSwitchMode.bind(this)}></input>
                </div>
            );
        } else {
            searchSection = (
                <div className="search-section enforcement-news">
                    <MonthCombo
                        month={this.state.query.month}
                        handleMonthChange={this.handleMonthChange.bind(this)}/>
                    <YearCombo
                        startYear={1997}
                        year={this.state.query.year}
                        handleYearChange={this.handleYearChange.bind(this)}/>
                    <input type="button" 
                        className="btn btn-primary"
                        value={t("enforcement.button.goToNameSearch")}
                        onClick={this.handleSwitchMode.bind(this)}></input>
                </div>
            );
        }

        return (
            <div style={{display:query.isLoading?"none":"block"}}>
                <Helmet>
                    <title>{t(`${category}.content.title`)} | {t('common:sfc')}</title>
                    <script>{gaScript}</script>
                    <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga4ScriptId}`}></script>
                    <script>{ga4Script}</script>
                </Helmet>

                <div className="headline">
                    {t(`${category}.content.title`)}
                </div>
                <div dangerouslySetInnerHTML={{ __html: t(`${category}.content.description`)}}></div>
                <br/>                
                {searchSection}
                <EnforcementNewsTable 
                    category={this.props.category} items={query.items} 
                    pageNo={query.pageNo} pageSize={query.pageSize} total={query.total}
                    handleNameSearch={this.handleNameSearch.bind(this)}
                    handlePageChange={this.handlePageChange.bind(this)}/>

                <br/>

                <p>{t('enforcement.footnotes.header')}</p>
                <ol>
                    <li>{t('enforcement.footnotes.note-1')}
                        <ol style={{"listStyleType" : "lower-alpha"}}>
                            <li>{t('enforcement.footnotes.note-1a')}</li>
                            <li>{t('enforcement.footnotes.note-1b')}</li>
                            <li>{t('enforcement.footnotes.note-1c')}</li>
                        </ol>
                    </li>
                    <li dangerouslySetInnerHTML={{__html:t('enforcement.footnotes.note-2')}}></li>
                    <li dangerouslySetInnerHTML={{__html:t('enforcement.footnotes.note-3')}}></li>
                    <li dangerouslySetInnerHTML={{__html:replacedoamin(t('enforcement.footnotes.note-4'))}}></li>
                </ol>
            </div>
        );
    }
}

export default withRouter(withTranslation()(EnforcementNewsListPanel));